// Where to go after signing in, for pages that send the user to /login and
// must resume afterwards (the MCP consent page, END-159). Only known in-app
// paths are honoured, so a crafted value can never redirect off-site.
const KEY = 'post_login_redirect';
const ALLOWED = /^\/mcp\/authorize\?request=[0-9a-f-]{36}$/;

export function savePostLoginRedirect(path: string): void {
  if (!ALLOWED.test(path)) return;
  try {
    sessionStorage.setItem(KEY, path);
  } catch {
    // Storage unavailable: the user lands on the dashboard instead.
  }
}

export function takePostLoginRedirect(): string | null {
  try {
    const path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return path && ALLOWED.test(path) ? path : null;
  } catch {
    return null;
  }
}
